import { Divider } from '@material-ui/core';
import React from 'react';
import { useStyles } from './styles';

function CustomDivider() {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Divider className={classes.divider} />
            <div className={classes.text}>OU</div>
        </div>
    );
}

export default CustomDivider;
